import { taskIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteCycleCounts = {
  name: "deleteCycleCounts" as const,
  input: z.object({ taskIds: z.array(taskIdFormat.schema).min(1) }),
  output: z.object({ deletedCount: z.number() }),
};
